// Search functionality — uses Shopify Predictive Search API
(function() {
    const overlay = document.getElementById('searchOverlay');
    const input = document.getElementById('searchInput');
    const resultsGrid = document.getElementById('searchResults');
    const noResults = document.getElementById('searchNoResults');
    const countEl = document.getElementById('searchCount');
    const closeBtn = document.getElementById('searchClose');
    if (!overlay || !input) return;

    let debounceTimer = null;

    // i18n strings
    var lang = (document.documentElement.lang || 'sr').toLowerCase();
    var isEN = lang === 'en';
    var I18N = {
        loading: isEN ? 'Loading...' : 'Ucitavanje...',
        noResultsFor: function(q){ return isEN ? ('No results for "' + q + '"') : ('Nema rezultata za "' + q + '"'); },
        count: function(n){
            if (isEN) return n + (n === 1 ? ' product' : ' products');
            return n + (n === 1 ? ' proizvod' : n < 5 ? ' proizvoda' : ' proizvoda');
        },
        priceOnRequest: isEN ? 'Price on request' : 'Cena na upit',
        addToCart: isEN ? 'Add to cart' : 'Dodaj u korpu'
    };

    function openSearch() {
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
        input.value = '';
        resultsGrid.innerHTML = '';
        noResults.style.display = 'none';
        countEl.textContent = '';
        setTimeout(function() { input.focus(); }, 100);
    }

    function closeSearch() {
        overlay.classList.remove('active');
        document.body.style.overflow = '';
    }

    // Open on search button click
    document.querySelectorAll('[aria-label="Pretraga"], [aria-label="Search"]').forEach(function(btn) {
        btn.addEventListener('click', openSearch);
    });

    // Close
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);
    overlay.addEventListener('click', function(e) {
        if (e.target === overlay) closeSearch();
    });
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && overlay.classList.contains('active')) closeSearch();
    });

    function renderCard(product) {
        var img = product.image;
        var imgHtml;
        if (img) {
            imgHtml = '<img src="' + img + '" alt="' + (product.title || '') + '" loading="lazy" width="400" height="533">';
        } else {
            imgHtml = '<div class="product-img-placeholder p-bg-1"><i class="fa-solid fa-image"></i></div>';
        }

        var priceHtml = '';
        if (product.price) {
            var priceNum = Math.floor(product.price);
            var formatted = new Intl.NumberFormat('sr-RS').format(priceNum);
            priceHtml = formatted + ' <span>RSD</span>';
        } else {
            priceHtml = I18N.priceOnRequest;
        }

        return '<a href="' + product.url + '" class="product-card">' +
            '<div class="product-img">' + imgHtml + '</div>' +
            '<div class="product-info">' +
                '<div class="product-brandd">' + (product.vendor || '') + '</div>' +
                '<div class="product-name">' + (product.title || '') + '</div>' +
                '<div class="product-price">' + priceHtml + '</div>' +
            '</div></a>';
    }

    function doSearch(query) {
        if (!query.trim()) {
            resultsGrid.innerHTML = '';
            noResults.style.display = 'none';
            countEl.textContent = '';
            return;
        }

        noResults.style.display = 'block';
        noResults.textContent = I18N.loading;

        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=24')
            .then(function(r) { return r.json(); })
            .then(function(data) {
                var products = (data.resources && data.resources.results && data.resources.results.products) || [];

                if (products.length === 0) {
                    resultsGrid.innerHTML = '';
                    noResults.style.display = 'block';
                    noResults.textContent = I18N.noResultsFor(query);
                    countEl.textContent = '';
                } else {
                    noResults.style.display = 'none';
                    countEl.textContent = I18N.count(products.length);
                    var html = '';
                    for (var i = 0; i < products.length; i++) {
                        html += renderCard(products[i]);
                    }
                    resultsGrid.innerHTML = html;
                }
            })
            .catch(function() {
                noResults.style.display = 'block';
                noResults.textContent = I18N.noResultsFor(query);
                countEl.textContent = '';
            });
    }

    input.addEventListener('input', function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
            doSearch(input.value);
        }, 300);
    });

    input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
            clearTimeout(debounceTimer);
            doSearch(input.value);
        }
    });
})();
